export default class NewsOverview {
    constructor(elm) {
        const showMoreButtonNews = elm.querySelector('#show-more--news');
        const overviewGridItems = elm.querySelector('#overview-grid__items');

        let page = 0;
        const pageSize = 10;

        function dateFormat(date) {
            const monthName = ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'];
            const mm = date.getMonth();
            const dd = date.getDate();

            return [dd, monthName[mm].toUpperCase(), date.getFullYear()].join(' ');
        }

        async function performSearch(addToResults) {
            if (addToResults) {
                page += 1;
            }

            const featuredArticleId = elm.querySelector('#featured-article-id').innerText;
            const searchUrl = '/Umbraco/Api/Search/GetNewsOverviewItems?page=' + page + '&pageSize=' + pageSize + '&ignoreItemId=' + featuredArticleId;

            const responseText = await fetch(searchUrl);
            const response = await responseText.json();
            const results = response.results;

            const gridItemTemplate = elm.querySelector('#grid-item-template');
            const templateBody = gridItemTemplate.querySelector('.col-12.col-md-6.col-lg-4');

            for (const i in results) {
                const item = templateBody.cloneNode(true);

                item.querySelector('.theme-card-2').href = results[i].url;
                item.querySelector('.theme-card-2__image').src = results[i].listImageUrl;
                item.querySelector('.theme-card-2__date').innerText = dateFormat(new Date(results[i].publishDate));
                item.querySelector('.theme-card-2__headline').innerText = results[i].headline;
                item.querySelector('.theme-card-2__manchet').innerHTML = results[i].manchet;

                overviewGridItems.appendChild(item);
            }

            if (response.totalResultCount <= pageSize * (page + 1)) {
                showMoreButtonNews.classList.add('hidden');
            } else {
                showMoreButtonNews.classList.remove('hidden');
            }
        }

        showMoreButtonNews.addEventListener('click', e => {
            e.preventDefault();
            if (!showMoreButtonNews.classList.contains('disabled')) {
                performSearch(true);
            }
        });

        performSearch(false);
    }
}
